/* istanbul ignore file */
import React from 'react';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { Typography, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialog } from 'components/InvoiceFeeNoteDialog/styles';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'components/InvoiceFeeNoteDialog/messages';
import InfoIcon from 'images/info-ic.svg';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';

export interface DynamiqDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  handleValidate: Function;
  children: any;
}

const DynamiqDialog: React.FC<DynamiqDialogProps> = (props): JSX.Element => {
  const { onClose, open } = props;
  const handleClose = () => {
    onClose(false);
  };
  const isIntervenant = currentIntervenantStorage?.get();

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid item xs={9}>
            <span
              style={{
                color: '#172C51 !important',
                fontSize: '20px',
                lineHeight: '24.42px',
              }}
            >
              {translate(messages.dialogInfoTitle, props)}
            </span>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Grid
          container
          direction="row"
          alignItems="center"
          alignContent="center"
          style={{
            gap: 10,
            background: '#E3F2FD',
            borderRadius: 8,
            padding: '3px',
          }}
        >
          <Grid item>
            <img src={InfoIcon} alt="infoIcon" />
          </Grid>
          <Grid item>
            <Typography className="success-title">
              {translate(
                isIntervenant
                  ? messages.dialogInfoSubTitle
                  : messages.dialogInfoManagerSubTitle,
                props,
              )}
            </Typography>
          </Grid>
        </Grid>
        {props.children}
      </DialogContent>
      <DialogActions className="success-actions">
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={translate(messages.cancel, props)}
        />
        <PrimaryButton
          onClick={() => props.handleValidate()}
          disableElevation
          data-testId="validate-button"
          className="primary-button"
          title={translate(messages.confirm, props)}
          disabled={false}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default injectIntl(DynamiqDialog);
